module.exports = __webpack_public_path__ + "static/media/checkmark-sm-green.9d269436.svg";